<template>
    <div class="">

        <div class="benefit-area two pt-100 pb-70">
            <div class="container">
                <div class="row align-items-center">

                    <div class="col-lg-6">
                        <div v-if="!pgLoading && items.image" class="benefit-img">
                            <img :src="(items.image) ? items.image.url : ''" alt="Benefit">
                            <img src="/assets/img/benefit-shape1.png" alt="Benefit">
                        </div>
                        <div v-if="pgLoading" class="benefit-img">
                            <img src="/assets/img/benefit-shape1.png" alt="Benefit">
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="section-title">
                            <h2 v-if="!pgLoading">
                                {{ ($i18n.locale == 'en') ? items.en.title : items.ar.title }}
                            </h2>
                            <h2 v-if="pgLoading" class="webkit-animation col-4 offset-4 webkit-none-50"></h2>
                        </div>

                        <div class="row" v-if="pgLoading">
                            <div v-for="(item, idx) in 4" :key="idx" class="col-sm-6 col-sm-6">
                                <div class="benefit-item webkit-animation webkit-300-200"></div>
                            </div>
                        </div>

                        <div class="row" v-if="!pgLoading">
                            <div v-for="(item, idx) in items.childs" :key="idx" class="col-sm-6 col-sm-6">
                                <div class="benefit-item">
                                    <img v-if="item.image" :src="item.image.url" style="width:80px;height: 80px">
                                    <h3>{{ ($i18n.locale == 'en') ? item.en.title : item.ar.title }}</h3>
                                    <p v-html="($i18n.locale == 'en') ? item.en.body : item.ar.body"></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'OurMission',
    components: {},
    data() {
        return {
            //
            items: [],
            pgLoading: true,
            refs: 'front-settings/our-mission'
        }
    },
    mounted() { },
    created() {
        //
        this.fetchData();
    },
    methods: {
        //
        fetchData() {
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL + '/' + this.refs,
                method: 'GET',
                data: {},
                headers: {
                    appId: process.env.VUE_APP_APPID
                },
            }
            this.axios(options)
                .then(res => {
                    this.pgLoading = false;
                    this.items = res.data.data;
                })
                .catch(() => {
                    //
                })
                .finally(() => { });
        },

    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
